import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b353ada8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scale-selector" }
const _hoisted_2 = {
  key: 0,
  disabled: ""
}
const _hoisted_3 = ["value"]

import { ref, watch, computed } from "vue";
import { storeToRefs } from "pinia";
import { useFretboardStore } from "@/stores/fretboard";
import { useScales } from "@/composables/useScales";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScaleSelector',
  setup(__props) {

const store = useFretboardStore();
const { selectedScaleName } = storeToRefs(store);
const { scales } = useScales();

const localSelectedScale = ref(selectedScaleName.value);

// Organize scales with line separators
const organizedScales = computed(() => {
  return [
    // Chromatic
    {
      key: "chromatic",
      value: "chromatic",
      name: scales.value.chromatic.name,
      isSeparator: false,
    },

    // Separator
    { key: "sep1", isSeparator: true },

    // Basic Scales
    {
      key: "major",
      value: "major",
      name: scales.value.major.name,
      isSeparator: false,
    },
    {
      key: "minor",
      value: "minor",
      name: scales.value.minor.name,
      isSeparator: false,
    },

    // Separator
    { key: "sep2", isSeparator: true },

    // Modal Scales
    {
      key: "ionian",
      value: "ionian",
      name: scales.value.ionian.name,
      isSeparator: false,
    },
    {
      key: "dorian",
      value: "dorian",
      name: scales.value.dorian.name,
      isSeparator: false,
    },
    {
      key: "phrygian",
      value: "phrygian",
      name: scales.value.phrygian.name,
      isSeparator: false,
    },
    {
      key: "lydian",
      value: "lydian",
      name: scales.value.lydian.name,
      isSeparator: false,
    },
    {
      key: "mixolydian",
      value: "mixolydian",
      name: scales.value.mixolydian.name,
      isSeparator: false,
    },
    {
      key: "aeolian",
      value: "aeolian",
      name: scales.value.aeolian.name,
      isSeparator: false,
    },
    {
      key: "locrian",
      value: "locrian",
      name: scales.value.locrian.name,
      isSeparator: false,
    },

    // Separator
    { key: "sep3", isSeparator: true },

    // Pentatonic & Blues
    {
      key: "major-pentatonic",
      value: "major pentatonic",
      name: scales.value["major pentatonic"].name,
      isSeparator: false,
    },
    {
      key: "minor-pentatonic",
      value: "minor pentatonic",
      name: scales.value["minor pentatonic"].name,
      isSeparator: false,
    },
    {
      key: "blues",
      value: "blues",
      name: scales.value.blues.name,
      isSeparator: false,
    },

    // Separator
    { key: "sep4", isSeparator: true },

    // Custom
    {
      key: "custom",
      value: "custom",
      name: scales.value.custom.name,
      isSeparator: false,
    },
  ];
});

watch(selectedScaleName, (newValue) => {
  localSelectedScale.value = newValue;
});

function updateScale() {
  store.setSelectedScale(localSelectedScale.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localSelectedScale).value = $event)),
      onChange: updateScale,
      class: "scale-select interactive-outline"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizedScales.value, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.key
        }, [
          (item.isSeparator)
            ? (_openBlock(), _createElementBlock("option", _hoisted_2, "─────"))
            : (_openBlock(), _createElementBlock("option", {
                key: 1,
                value: item.value
              }, _toDisplayString(item.name), 9, _hoisted_3))
        ], 64))
      }), 128))
    ], 544), [
      [_vModelSelect, localSelectedScale.value]
    ])
  ]))
}
}

})